<template>
  <td>
    <!-- Booleans -->
    <template v-if="typeof row[col] === 'boolean' && cellChecks">
      <span
        v-if="getLoadingCell(row.id, col)"
        class="spinner-border spinner-border-sm my-1 ms-4"
        role="status"
        aria-hidden="true"
      />
      <BootstrapCheck
        v-else
        :id="`${row.id}-${col}`"
        :model-value="row[col]"
        :scale="1"
        :disabled="cellsDisabled"
        @update:model-value="(value: boolean) => $emit('update', col, row, value)"
      />
    </template>
    <!-- Strings, numbers, etc. -->
    <template v-else>
      {{ String(row[col]) && !!row[col] ? String(row[col]) : '-' }}
    </template>
  </td>
</template>
<script lang="ts" setup>
const props = defineProps<{
  row: any;
  col: string;
  loadingCol?: string;
  loadingRow?: string;
  cellChecks?: boolean;
  colsValues: string[];
}>();
defineEmits<{
  update: [col: string | number, row: any, value: boolean];
}>();
const getLoadingCell = (id: string, colKey: string) =>
  id === props.loadingRow && colKey === props.loadingCol;
const cellsDisabled = computed(
  () => props.loadingCol !== undefined || props.loadingRow !== undefined,
);
</script>
